import React, { useState, useEffect, useRef } from 'react';
import { Table, Button, Typography, Row, Modal, Form, Input, Popconfirm } from 'antd';
import { PlusOutlined, DeleteFilled } from '@ant-design/icons';
import SignaturePadContainer from './SignaturePadContainer';
import useAuth from '../../hooks/useAuth';
import { useTranslation } from 'react-i18next';

const { Title } = Typography;

const Esign = ({ esignature, setEsignature }) => {

  const [openSignPad, setopenSignPad] = useState(false);
  const [signatureDataURL, setSignatureDataURL] = useState(null);
  const signaturePadRef = useRef();
  const { userConfig } = useAuth();
  const { t } = useTranslation();

  const handleSaveSignature = () => {
    const signaturePad = signaturePadRef.current;
    if (!signaturePad) return;

    if (signaturePad.isEmpty()) {
      alert('Please provide a signature first.');
    } else {
      const signatureUrl = signaturePad.toDataURL()
      setSignatureDataURL(signatureUrl);
      setEsignature(signatureUrl);
      setopenSignPad(false)
    }
  }

  return (
    <div>
      <div>
        <Title style={{ fontSize: 16, fontWeight: 600 }}>{t('eSignature.supervisorESignature')}</Title>
        {/* Supervisor E-Signature */}
      </div>
      
      {esignature && (
        <div style={{ marginTop: '10px' }}>
          <img
            src={esignature}
            alt="Signature"
            width={115}
            height={50}
            style={{ border: '1px solid #ccc' }}
          />
        </div>
      )}

      <Button 
        style={{ color: '#1677FF', borderColor: '#1677FF', marginTop: '5px' }}
        disabled={userConfig?.role === 'payroll'} 
        type='default' onClick={() => setopenSignPad(true)}>
        {esignature ? t('eSignature.updateESign') : t('eSignature.provideESign')}
      </Button>

      <Modal
        title={t('eSignature.adoptYourSignature')}
        okText={t('eSignature.adoptAndSign')}
        open={openSignPad}
        onOk={handleSaveSignature}
        onCancel={() => setopenSignPad(false)}
        maskClosable={false} // Prevent closing on outside click
        width='90%'>
        <SignaturePadContainer signaturePadRef={signaturePadRef} />
      </Modal>
    </div>
  )
};

export default Esign;